// import React, { useEffect, useState } from 'react';
// import { NavLink, useLocation } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import logo from "../assets/logo_.jpg";
// import '../styles/Navbar.css';
// import Socials from './Socials';

// export default function Navbar() {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrolled = window.pageYOffset > 50;
//       setIsScrolled(scrolled);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Close mobile menu when route changes
//   useEffect(() => {
//     setIsMobileMenuOpen(false);
//   }, [location]);

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };

//   const closeMobileMenu = () => {
//     setIsMobileMenuOpen(false);
//   };

//   return (
//     <>
//       <nav className={`modern-navbar ${isScrolled ? 'scrolled' : ''}`}>
//         <div className="navbar-container">
//           {/* Logo Section */}
//           <NavLink className="navbar-logo-link" to="/" onClick={closeMobileMenu}>
//             <div className="logo-wrapper">
//               <img src={logo} alt="Spardhaweb Logo" className="navbar-logo-img" />
//               <span className="logo-text">Spardhaweb</span>
//             </div>
//           </NavLink>

//           {/* Desktop Navigation */}
//           <div className="navbar-menu desktop-menu">
//             <NavLink 
//               to="/" 
//               end
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">🏠</span>
//               <span className="nav-text">Home</span>
//             </NavLink>

//             <NavLink 
//               to="/premium"
//               className={({ isActive }) => `nav-item premium-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">⭐</span>
//               <span className="nav-text">Premium</span>
//               <span className="premium-badge">New</span>
//             </NavLink>

//             <NavLink 
//               to="/subjects"
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">📝</span>
//               <span className="nav-text">Test Series</span>
//             </NavLink>

//             <NavLink 
//               to="/articles"
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">📰</span>
//               <span className="nav-text">Current Affairs</span>
//             </NavLink>

//             <NavLink 
//               to="/ebooks"
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">📚</span>
//               <span className="nav-text">E-Books</span>
//             </NavLink>

//             <NavLink 
//               to="/latest-updates"
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">🔔</span>
//               <span className="nav-text">Updates</span>
//             </NavLink>

//             <NavLink 
//               to="/about-us"
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">ℹ️</span>
//               <span className="nav-text">About</span>
//             </NavLink>

//             <NavLink 
//               to="/contact-us"
//               className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
//             >
//               <span className="nav-icon">📧</span>
//               <span className="nav-text">Contact</span>
//             </NavLink>
//           </div>

//           {/* Social Icons & Mobile Toggle */}
//           <div className="navbar-actions">
//             <div className="social-icons-nav">
//               <Socials />
//             </div>
            
//             <button 
//               className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
//               onClick={toggleMobileMenu}
//               aria-label="Toggle menu"
//               aria-expanded={isMobileMenuOpen}
//             >
//               <span className="hamburger-line"></span>
//               <span className="hamburger-line"></span>
//               <span className="hamburger-line"></span>
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* Mobile Navigation Overlay */}
//       {isMobileMenuOpen && (
//         <div className="mobile-overlay" onClick={closeMobileMenu}></div>
//       )}

//       {/* Mobile Navigation Menu */}
//       <div className={`mobile-menu-container ${isMobileMenuOpen ? 'show' : ''}`}>
//         <div className="mobile-menu">
//           <div className="mobile-menu-header">
//             <h3>Menu</h3>
//             <button className="close-mobile-menu" onClick={closeMobileMenu}>
//               ✕
//             </button>
//           </div>

//           <NavLink 
//             to="/" 
//             end
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">🏠</span>
//             <span className="nav-text">Home</span>
//           </NavLink>

//           <NavLink 
//             to="/premium"
//             className={({ isActive }) => `mobile-nav-item premium-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">⭐</span>
//             <span className="nav-text">Premium</span>
//             <span className="premium-badge">New</span>
//           </NavLink>

//           <NavLink 
//             to="/subjects"
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">📝</span>
//             <span className="nav-text">Free Test Series</span>
//           </NavLink>

//           <NavLink 
//             to="/articles"
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">📰</span>
//             <span className="nav-text">Current Affairs</span>
//           </NavLink>

//           <NavLink 
//             to="/ebooks"
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">📚</span>
//             <span className="nav-text">E-Books</span>
//           </NavLink>

//           <NavLink 
//             to="/latest-updates"
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">🔔</span>
//             <span className="nav-text">Latest Updates</span>
//           </NavLink>

//           <NavLink 
//             to="/about-us"
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">ℹ️</span>
//             <span className="nav-text">About Us</span>
//           </NavLink>

//           <NavLink 
//             to="/contact-us"
//             className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}
//             onClick={closeMobileMenu}
//           >
//             <span className="nav-icon">📧</span>
//             <span className="nav-text">Contact Us</span>
//           </NavLink>

//           <div className="mobile-menu-footer">
//             <Socials />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom'; // ✅ added useNavigate
import Cookies from 'js-cookie';
import logo from "../assets/logo_.jpg";
import '../styles/Navbar.css';
import Socials from './Socials';
import { useAuth } from '../context/AuthContext'; // ✅ import useAuth hook

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate(); // ✅ for redirect after logout

  const { user, login, logout, isAuthenticated } = useAuth(); // ✅ grab what we need

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset > 50;
      setIsScrolled(scrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // ✅ Logout handler
  const handleLogout = async () => {
    await logout();
    closeMobileMenu();
    navigate('/');
  };

  // ✅ Login handler (triggers Google OAuth redirect)
  const handleLogin = () => {
    login();
    closeMobileMenu();
  };

  return (
    <>
      <nav className={`modern-navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">

          {/* Logo */}
          <NavLink className="navbar-logo-link" to="/" onClick={closeMobileMenu}>
            <div className="logo-wrapper">
              <img src={logo} alt="Spardhaweb Logo" className="navbar-logo-img" />
              <span className="logo-text">Spardhaweb</span>
            </div>
          </NavLink>

          {/* Desktop Navigation */}
          <div className="navbar-menu desktop-menu">
            <NavLink to="/" end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">🏠</span>
              <span className="nav-text">Home</span>
            </NavLink>

            <NavLink to="/premium" className={({ isActive }) => `nav-item premium-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">⭐</span>
              <span className="nav-text">Premium</span>
              <span className="premium-badge">New</span>
            </NavLink>

            <NavLink to="/subjects" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">📝</span>
              <span className="nav-text">Test Series</span>
            </NavLink>

            <NavLink to="/articles" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">📰</span>
              <span className="nav-text">Current Affairs</span>
            </NavLink>

            <NavLink to="/ebooks" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">📚</span>
              <span className="nav-text">E-Books</span>
            </NavLink>

            <NavLink to="/latest-updates" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">🔔</span>
              <span className="nav-text">Updates</span>
            </NavLink>

            <NavLink
              to="/typing-practice"
              className={({ isActive }) =>
                `mobile-nav-item premium-item ${isActive ? 'active' : ''}`
              }
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">⌨️</span>
            <span className="premium-badge">New</span>
              <span className="nav-text">Typing Practice</span>
            </NavLink>

            {/* <NavLink to="/about-us" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">ℹ️</span>
              <span className="nav-text">About</span>
            </NavLink>

            <NavLink to="/contact-us" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="nav-icon">📧</span>
              <span className="nav-text">Contact</span>
            </NavLink> */}

            {/* ✅ Desktop Auth Button */}
            {isAuthenticated ? (
              <div className="nav-user-section">
                {user?.picture && (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="nav-user-avatar"
                    referrerPolicy="no-referrer"
                  />
                )}
                <button className="nav-auth-btn logout-btn" onClick={handleLogout}>
                  <span className="nav-icon">🚪</span>
                  <span className="nav-text">Logout</span>
                </button>
              </div>
            ) : (
              <button className="nav-auth-btn login-btn" onClick={handleLogin}>
                <span className="nav-icon">👤</span>
                <span className="nav-text">Login</span>
              </button>
            )}
          </div>

          {/* Actions */}
          <div className="navbar-actions">
            <div className="social-icons-nav">
              <Socials />
            </div>
            <button
              className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle menu"
              aria-expanded={isMobileMenuOpen}
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="mobile-overlay" onClick={closeMobileMenu}></div>
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu-container ${isMobileMenuOpen ? 'show' : ''}`}>
        <div className="mobile-menu">
          <div className="mobile-menu-header">
            {/* ✅ Show user info in mobile header if logged in */}
            {isAuthenticated ? (
              <div className="mobile-user-info">
                {user?.picture && (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="mobile-user-avatar"
                    referrerPolicy="no-referrer"
                  />
                )}
                <span className="mobile-user-name">{user?.name}</span>
              </div>
            ) : (
              <h3>Menu</h3>
            )}
            <button className="close-mobile-menu" onClick={closeMobileMenu}>✕</button>
          </div>

          <NavLink to="/" end className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">🏠</span>
            <span className="nav-text">Home</span>
          </NavLink>

          <NavLink to="/premium" className={({ isActive }) => `mobile-nav-item premium-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">⭐</span>
            <span className="nav-text">Premium</span>
            <span className="premium-badge">New</span>
          </NavLink>

          <NavLink to="/subjects" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">📝</span>
            <span className="nav-text">Free Test Series</span>
          </NavLink>

          <NavLink to="/articles" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">📰</span>
            <span className="nav-text">Current Affairs</span>
          </NavLink>

          <NavLink to="/ebooks" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">📚</span>
            <span className="nav-text">E-Books</span>
          </NavLink>

          <NavLink to="/latest-updates" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">🔔</span>
            <span className="nav-text">Latest Updates</span>
          </NavLink>

          <NavLink to="/typing-practice" className={({ isActive }) => `mobile-nav-item premium-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">⌨️</span>
            <span className="premium-badge">New</span>
            <span className="nav-text">Typing Practice</span>
          </NavLink>

          {/* <NavLink to="/about-us" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">ℹ️</span>
            <span className="nav-text">About Us</span>
          </NavLink>

          <NavLink to="/contact-us" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`} onClick={closeMobileMenu}>
            <span className="nav-icon">📧</span>
            <span className="nav-text">Contact Us</span>
          </NavLink> */}

          {/* ✅ Mobile Auth Button */}
          {isAuthenticated ? (
            <button className="mobile-nav-item mobile-auth-btn logout-btn" onClick={handleLogout}>
              <span className="nav-icon">🚪</span>
              <span className="nav-text">Logout</span>
            </button>
          ) : (
            <button className="mobile-nav-item mobile-auth-btn login-btn" onClick={handleLogin}>
              <span className="nav-icon">👤</span>
              <span className="nav-text">Login with Google</span>
            </button>
          )}

          <div className="mobile-menu-footer">
            <Socials />
          </div>
        </div>
      </div>
    </>
  );
}